import { render, staticRenderFns } from "./AccountPanel.vue?vue&type=template&id=0af56061&scoped=true"
import script from "./AccountPanel.vue?vue&type=script&lang=js"
export * from "./AccountPanel.vue?vue&type=script&lang=js"
import style0 from "./AccountPanel.vue?vue&type=style&index=0&id=0af56061&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af56061",
  null
  
)

export default component.exports